module.exports = {
    ARROW_KEYS: [
    ['Down', 'Up'],
    ['Left', 'Right'],
  ],
};
